<template>
  <div class="related-forums">
    <h3 class="typo-headline-6">Foros Relacionados</h3>
    <ul v-if="relatedForums.length">
      <related-forum
        v-for="forum in relatedForums"
        :key="forum.id"
        :forum="forum"
      />
    </ul>
    <p v-else class="typo-body-2">Cargando foros relacionados...</p>
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';
const axios = forumApi;
import RelatedForum from './RelatedForum.vue';

export default {
  name: 'RelatedForumsContainer',
  components: {
    RelatedForum
  },
  props: {
    currentSectionId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      relatedForums: [],
      loading: true,
      error: null,
      currentSectionCategory: null
    };
  },
  mounted() {
    this.fetchRelatedForums();
  },
  methods: {
    fetchRelatedForums() {
      // Get all forum sections
      axios.get('/api/forum-sections')
        .then(response => {
          if (response.data && response.data.success) {
            const sections = response.data.sections;
            
            // Find which category the current section belongs to
            let currentSection = null;
            
            // Check in main sections
            for (const section of sections.main || []) {
              if (section.id == this.currentSectionId) {
                currentSection = section;
                this.currentSectionCategory = 'main';
                break;
              }
            }
            
            // Check in secondary sections if not found
            if (!currentSection) {
              for (const section of sections.secondary || []) {
                if (section.id == this.currentSectionId) {
                  currentSection = section;
                  this.currentSectionCategory = 'secondary';
                  break;
                }
              }
            }
            
            // Get all sections from the same category, excluding the current one
            if (this.currentSectionCategory) {
              this.relatedForums = sections[this.currentSectionCategory]
                .filter(section => section.id != this.currentSectionId)
                .map(section => ({
                  id: section.id,
                  name: section.title,
                  slug: section.slug || section.id // Include slug for routing
                }));
            }
          }
        })
        .catch(err => {
          console.error('Error fetching related forums:', err);
          this.error = 'Error al cargar foros relacionados';
          this.relatedForums = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.related-forums {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 15px;
  color: var(--color-text-primary);
}

.related-forums h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

/* List Reset */
ul {
  padding: 0;
  margin: 0;
}
</style> 